import React, { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";


import calendarIcon from "../assets/icons/calendar-plus.svg";
import { google } from "calendar-link";
import { DeviceContext } from "../context/deviceContext";

export default function CalculateAuctionTime({
    auctionStartTime,
    auctionEndTime,
    title,
    description,
    location,
    isAuction,
    property
}) {
    const [timeLeft, setTimeLeft] = useState(0);
    const [auctionEnded, setAuctionEnded] = useState(false);
    const [auctionStarted, setAuctionStarted] = useState(false);
    const { isMobile } = useContext(DeviceContext);

    // Function to calculate time left
    const handleTimeLeft = useCallback(() => {
        const currTime = new Date().getTime();
        const startTime = new Date(auctionStartTime).getTime();
        const endTime = new Date(auctionEndTime).getTime();

        if (isAuction) {
            const remainingEndTime = endTime - currTime;
            setTimeLeft(Math.max(remainingEndTime, 0));
            setAuctionEnded(remainingEndTime <= 0);
        } else {
            const remainingTime = startTime - currTime;
            const remainingEndTime = endTime - currTime;
            setAuctionEnded(remainingEndTime <= 0);
            setTimeLeft(Math.max(remainingTime, 0));
            setAuctionStarted(remainingTime <= 0);
        }
    }, [auctionStartTime, auctionEndTime, isAuction]);

    // Update state when auctionStartTime or auctionEndTime changes
    useEffect(() => {
        handleTimeLeft(); // Run immediately on mount & prop changes
        const interval = setInterval(handleTimeLeft, 1000); // Update every second
        return () => clearInterval(interval);
    }, [handleTimeLeft, auctionEnded]);

    // Convert milliseconds into a readable format
    const formatTimeLeft = (ms) => {
        const seconds = Math.floor((ms / 1000) % 60);
        const minutes = Math.floor((ms / 1000 / 60) % 60);
        const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
        const days = Math.floor(ms / (1000 * 60 * 60 * 24));
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };

    // Function to handle calendar icon click
    const handleCalendarClick = () => {
        const calendarData = {
            startDate: new Date(auctionStartTime),
            endDate: new Date(auctionEndTime),
            title,
            description,
            location
        };

        const link = google(calendarData);
        window.open(link, "_blank");
    };


    const navigate = useNavigate();


     // Handle cardClick
    const handleCardClick = ()=>{
        navigate(`/properties/property/${property._id}`);

    }
    


    return (
        <div className={`auctionDetail ${!isMobile && "auctionInDetail"} ${isAuction && "auctionPageTimerDetail"} ${auctionStarted ? "auctionStarted" : ""}`} onClick={handleCardClick}>
            {auctionStartTime === 0 || auctionEndTime === 0? (
                <p className="auction auctionParagraph notOnAuction">
                    Property not on auction yet! You will be notified as soon as the seller has scheduled one.
                </p>
            ) : auctionEnded ? (
                <p className="auction auctionParagraph auctionEnded">Auction has ended.</p>
            ) : isAuction ? (
                <div className="auctionPageTimer">
                    <p className={`auction ${isAuction && "auctionPageTimerTitle"}`}>Ends in:</p>
                    <p className={`timer ${isAuction && "auctionTimer"}`}>{formatTimeLeft(timeLeft)}</p>
                </div>
            ) : auctionStarted ? (
                <p className="auction auctionParagraph">Auction is Live!</p>
            ) : (
                <>
                    {isMobile ? (
                        <div className="propertyAuctionTimer">
                            <p className="auction">Auction in:</p>
                            <p className="timer">{formatTimeLeft(timeLeft)}</p>
                        </div>
                    ) : (
                        <div className="auctionIn">
                            <p className="auction">Auction in:</p>
                            <p className="timer timerIn">{formatTimeLeft(timeLeft)}</p>
                        </div>
                    )}

                    {!isAuction && auctionStartTime !== 0 && auctionEndTime !== 0 && (
                        <img
                            src={calendarIcon}
                            className="addToCalendar"
                            alt="Calendar Icon"
                            onClick={handleCalendarClick}
                        />
                    )}
                </>
            )}
        </div>
    );
}
